export const categories = [
  {
    key: "drama",
    name: "剧情片",
    en: "DRAMA",
    icon: "ri-film-line",
    cover: "crimsonCurtain",
    desc: "以人物关系与情绪推进为核心，讲究叙事节奏、光影与氛围的成人影视作品。适合喜欢完整故事与细腻表演的观众。",
  },
  {
    key: "ethic",
    name: "伦理片",
    en: "ETHIC",
    icon: "ri-heart-2-line",
    cover: "windowShadow",
    desc: "聚焦家庭、婚姻与亲密关系中的灰色地带，用克制的镜头语言讨论责任、欲望与选择之间的拉扯。",
  },
  {
    key: "urban",
    name: "都市情缘",
    en: "URBAN",
    icon: "ri-building-4-line",
    cover: "rooftopDusk",
    desc: "发生在深夜办公室、末班巴士与便利店里的城市情感故事，节奏轻快，贴近当代都市人的真实生活。",
  },
  {
    key: "classic",
    name: "古装情色",
    en: "CLASSIC",
    icon: "ri-moon-line",
    cover: "moonGarden",
    desc: "东方古典美学语境下的作品，包含宫廷、花街、宅院等题材，强调服化道、构图与时代氛围的还原。",
  },
  {
    key: "suspense",
    name: "悬疑情欲",
    en: "SUSPENSE",
    icon: "ri-eye-line",
    cover: "nightAlley",
    desc: "以密室、失踪、身份反转为主线，在悬念推进中展开人物之间复杂的心理博弈与情感关系。",
  },
];

export const regions = ["日本", "韩国", "中国香港", "中国台湾", "泰国"];

export const years = [2026, 2025, 2024, 2023];

export const sortOptions = [
  { key: "latest", label: "最新更新", icon: "ri-time-line" },
  { key: "hot", label: "热门程度", icon: "ri-fire-line" },
  { key: "rating", label: "评分优先", icon: "ri-star-line" },
];